import { scaleSqrt, max } from "d3";
import LeafletMap from "./LeafletMap";
import React, { useMemo, useRef } from "react";
import ResetZoomButton from "./Components/ResetZoomButton";
import Legend from "./Components/Legend";
import KeyFiguresSection from "./Components/KeyFiguresSection";
import OverrideIcon from "./Components/OverrideIcon";

const MapSection = (props) => {
  const hoverTooltipRef = useRef();
  //sizings
  const tooltipWidth = 250;

  const sizeScale = useMemo(() => {
    return scaleSqrt()
      .domain([
        1,
        max([
          max(props.newData, (d) => d.pv_count),
          max(props.newData, (d) => d.demo_count),
        ]),
      ])
      .range([3, 14]);
  }, [props.newData]);

  const showTooltipHandler = (country, event, iconExplanation) => {
    hoverTooltipRef.current.style.display = "block";
    if (country === "United States of America") {
      hoverTooltipRef.current.firstChild.textContent =
        "For US data and analysis, see the North America Regional Overview";
    } else {
      document.querySelector(
        "#hover-tooltip"
      ).firstChild.textContent = `${country}${
        iconExplanation ? " | " + iconExplanation : ""
      }`;
    }
  };
  const moveTooltipHandler = (event) => {
    let xPoint = event.containerPoint ? event.containerPoint.x : event.clientX;
    let yPoint = event.containerPoint ? event.containerPoint.y : event.clientY;
    let position = event.containerPoint ? "absolute" : "fixed";
    hoverTooltipRef.current.style.left = `${xPoint + 10}px`;
    hoverTooltipRef.current.style.top = `${yPoint - 35}px`;
    hoverTooltipRef.current.style.position = position;
  };
  const hideTooltipHandler = () => {
    hoverTooltipRef.current.style.display = "none";
  };
  const markerClickHandler = (country) => {
    props.setPositionHandler(country);
  };

  const overrideIconHeight = 45;
  const iconGap = 8;

  return (
    <div
      style={{
        position: "relative",
        width: props.width,
        height: props.height,
      }}
    >
      <LeafletMap
        region={props.region}
        zoomedCountry={props.zoomedCountry && props.zoomedCountry.country}
        setPositionHandler={props.setPositionHandler}
        resetPosition={props.resetPosition}
        trendCountries={props.trendCountries}
        mapBoxCoords={props.mapBoxCoords}
        setMap={props.setMap}
        map={props.map}
        center={props.startingPosition.center}
        zoom={props.startingPosition.zoom}
        width={props.width}
        height={props.height}
        newData={props.newData}
        sizeScale={sizeScale}
        iconsRef={props.iconsRef}
        geoJsonRef={props.geoJsonRef}
        markerClickHandler={markerClickHandler}
        showTooltipHandler={showTooltipHandler}
        hideTooltipHandler={hideTooltipHandler}
        moveTooltipHandler={moveTooltipHandler}
        newCountryList={props.newCountryList}
      />
      <KeyFiguresSection
        height={props.height}
        tooltipStatus={props.zoomedCountry}
        width={props.width}
        tooltipWidth={tooltipWidth}
        keyFigures={props.keyFigures}
        period={props.period}
        countryShown={props.zoomedCountry}
        showTooltipHandler={props.showTooltipHandler}
        hideTooltipHandler={props.hideTooltipHandler}
        moveTooltipHandler={props.moveTooltipHandler}
      />
      {/* <PredictionFigure 
      tooltipWidth={tooltipWidth}
      /> */}
      <Legend sizeScale={sizeScale} width={props.width} />
      <div
        ref={hoverTooltipRef}
        id="hover-tooltip"
        className="hover-tooltip"
        style={{ borderRadius: 10 }}
      >
        <p>{props.hoverTooltipStatus && props.hoverTooltipStatus.content}</p>
      </div>
      <ResetZoomButton
        resetPosition={props.resetPosition}
        resetButtonDisplay={props.zoomedCountry}
      />
      <div
        style={{
          top: props.height,
          transform: `translate(${iconGap}px,-${
            Object.keys(props.trendCountries).length *
            (overrideIconHeight + iconGap)
          }px)`,
        }}
        className="override-icons"
      >
        {Object.keys(props.trendCountries).map((country, index) => {
          if (country === "Middle East")
            return (
              <OverrideIcon
                country={country}
                trendCountries={props.trendCountries}
                hideTooltipHandler={hideTooltipHandler}
                moveTooltipHandler={moveTooltipHandler}
                iconGap={iconGap}
                key={index}
                markerClickHandler={markerClickHandler}
                showTooltipHandler={showTooltipHandler}
              />
            );
        })}
      </div>
    </div>
  );
};

export default MapSection;
